import __request__ from "routing/request";
export function checkSubscriptions(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations.office365.api.O365Resource/office365/checkSubscriptions", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, setup_wizard = false, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations.office365.api.O365Resource/office365/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function startSubscription(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations.office365.api.O365Resource/office365/startSubscription", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
